module.exports = __webpack_public_path__ + "media/FaktSoftPro-Normal_16e7b1.eot";